import _ from 'underscore';
import { projectFlag, xmlToJSON, guid } from '../base';

var Strophe = window.Strophe;
var client_access_key = 'client_access_key';

export const clientAccessKey = localStorage[client_access_key] || guid();
localStorage[client_access_key] = clientAccessKey;

export function log(type, ...args) {
    let prefix = projectFlag ? `[${projectFlag}]` : '';
    console.log(`${prefix}[Strophe.${type}]`, ...args);
}

export function convertToJSON(xml) {
    let json = xmlToJSON(xml.outerHTML);
    let body;

    try {
        json = json[_.keys(json)[0]];
        body = json.body.__text || json.body;
        body && (body = JSON.parse(body));
        json.body = body;
    } catch (ex) {}


    for (var k in json) {
        if (k.indexOf("_") === 0) {
            json[k.slice(1)] = json[k];
            delete json[k];
        }
    }
    json.from && (json.from_jid = Strophe.getBareJidFromJid(json.from));

    return json;
}


// WEBPACK FOOTER //
// ./src/utils/webIM/base.js